import { useDraftMode } from '@/ui/pages/pipelineConfigPage/context/DraftModeContext';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import { FC } from 'react';

type Props = Pick<ModalProps, 'isOpen' | 'onClose'>;

const DiscardChangesModal: FC<Props> = ({ isOpen, onClose }) => {
  const { phase, cancel } = useDraftMode();

  return (
    <Modal title="Discard changes" isOpen={isOpen} onClose={onClose}>
      <Modal.Body>
        Are you sure you want to discard all changes? This action cannot be
        undone.
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="secondary" onClick={() => onClose?.()}>
            Cancel
          </Button>
          <Button
            colour="negative"
            isProcessing={phase.startsWith('cancelling')}
            onClick={() => {
              void cancel();
              onClose?.();
            }}
          >
            Discard
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DiscardChangesModal;
